<template>
   
    <div class="textbox" style="width: 100%;">
        <label>Vendor Code </label>
        <div>
            <InputText :placeholder="placeholder" v-model="inputText" :maxlength="maxlength"/>
            <Button label="Check" severity="info" @click="CheckVendorCode(true)"  />
        </div>
    </div>
    <Dialog v-model:visible="showDialog" modal header="Vendor Code" :style="{ width: '60vw' }">
        <div>
            <DataTable 
            :value="sapVendorcode" 
            dataKey="LIFNR" 
            tableStyle="min-width: 40rem" >
               

                <Column field="IsSelect" header="IsSelect">
                   <template #body="slotProps">
                       <Checkbox v-model="slotProps.data.IsSelect" :binary="true" :disabled="!MaterialGroup && (slotProps.data.IsUsed==true || slotProps.data.IsApplied==true)" />          
                   </template>
                 </Column>

                <Column field="LIFNR" header="Vendor Code"></Column>
                <Column field="NAME" header="Vendor Name"></Column>
                <Column header="in use">
                    <template #body="slotProps">
                        <i class="pi pi-check" v-if="slotProps.data.IsUsed==true"></i>
                    </template>
                </Column>
                <Column header="in apply">
                    <template #body="slotProps">
                        <i class="pi pi-check" v-if="slotProps.data.IsApplied==true"></i>
                    </template>
                </Column>
                
              
            </DataTable>
            <br />
            <Button label="確定" @click="Confirm"></Button>
        </div>
    </Dialog>
 </template>  
<script>

import Service from "../../service/service";
import SapService from "../../service/SapService";

export default {
    props: ["modelValue",'maxlength'],
    emits: ["update:modelValue","onConfirm"],
    
    data() {
        return {
            
            inputText: "",
            sapVendorcode: [],
            selectedVendorcode: [],
            showDialog: false,
            placeholder: "請輸入5碼"
        }
    },
    Service: null,
    SapService: null,
    created() {
        this.Service = new Service();
        this.SapService = new SapService();
        if (this.CodeLength == 5) {
            this.placeholder = "請輸入完整5碼"
        }
        this.selectedVendorcode=this.modelValue;
    },
    methods: {
       
        async CheckVendorCode(open) {
            let self=this;
            this.VendorCode_lst = [];
             

          

            if (this.inputText.length > 0) {

                    await this.SapService.GetSpuervisorSAPVendorCode(this.inputText).then((data) => {
                        self.sapVendorcode = data
                    })
                
            }

            if (this.sapVendorcode.length == 0) {
                this.showDialog = false
                this.$toast.add({
                    severity: 'warn', summary: 'Warn Message', detail: '查無資料', life: 3000
                })
            }
            else {
                this.showDialog = open
            }
        },
      
       Confirm() {
           
            this.showDialog = false;
            let lst=this.sapVendorcode.filter(x=>x.IsSelect==true);
            this.$emit("onConfirm", lst );
        }

    },
    watch: {
       
       
    },
    computed: {
    isLoading() {
      return this.$store.state.isLoading;
      //return false;
    },
    user() {
     return this.$store.state.user;
    },
    user_userName() {
     return this.$store.state.user?.userName;
    },
    user_buyerMapping() {
     return this.$store.state.user?.buyerMapping;
    },
    user_sourcerMapping() {
     return this.$store.state.user?.sourcerMapping;
    },
    user_vendorMapping() {
     return this.$store.state.user?.vendorMapping;
    },
    user_mfgcode() {
     return this.$store.state.user?.mfgcode;
    },
    user_mfgsearchterm() {
     return this.$store.state.user?.mfgsearchterm;
    },
    user_roles() {
     return this.$store.state.user?.Roles;
    },
    clientId() {
     return this.$store.state.user?.clientId;
    },


    is_VIPAdmin(){
       return this.user_roles && this.user_roles.includes('VIPAdmin');
    },
    is_SCSI(){
       return this.user_roles && this.user_roles.includes('SCSI');
    },
    is_Sourcer(){
       return this.user_roles && this.user_roles.includes('Sourcer');
    },
    is_Buyer(){
       return this.user_roles && this.user_roles.includes('Buyer');
    },
    is_CompalUser(){
       return this.user_roles && this.user_roles.includes('CompalUser');
    },
    is_VendorUser(){
       return this.user_roles && this.user_roles.includes('VendorUser');
    },
    is_Supervisor(){
       return this.user_roles && this.user_roles.includes('Supervisor');
    },
    token() {
     return this.$store.state.token;
    },
    refreshToken() {
     return this.$store.state.refreshToken;
    },
    sessionCode() {
     return this.$store.state.sessionCode;
    },


     

  },
}
</script>
  
  